import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import LiveDataShowcase from './components/LiveDataShowcase';
import FeaturesSection from './components/FeaturesSection';
import HotArticles from './components/HotArticles';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryCards />
        <LiveDataShowcase />
        <FeaturesSection />
        <HotArticles />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '彩客网新版官网 - 全新升级体验更流畅',
            description:
              '彩客网新版官网全面升级上线，提供极速彩票数据查询、开奖结果实时推送、智能分析预测等核心服务，覆盖双色球、大乐透、福彩3D、排列三、七星彩等主流彩种。',
            url: 'https://www.caikewang.com',
            isPartOf: {
              '@type': 'WebSite',
              name: '彩客网',
              url: 'https://www.caikewang.com',
            },
            mainEntity: {
              '@type': 'Organization',
              name: '彩客网',
              url: 'https://www.caikewang.com',
              foundingDate: '2015',
              contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'customer service',
                email: 'service@caikewang.com',
              },
            },
          }),
        }}
      />
    </>
  );
}